import React from 'react';
import './sales.css';
import UsecaseTitle from "./usecase-title/usecase-title";
import Benefits from "./benefits/benefits";
import UseCaseFeatures from "./use-case-features/use-case-features";


function Sales() {
   return(
       <div className="use-case-page animate-page">
          <div className="marketing-sec sec-bottom-padding">
             <UsecaseTitle />
          </div>

          <div className="benefit-sec bottom-padding-100">
             <Benefits />
          </div>

          <div className="feature-sec bottom-padding-100">
             <UseCaseFeatures />
          </div>
       </div>
   )
}

export default Sales;
